import DateInput from "@/components/form/Date";
import Input from "@/components/form/Input";
import Textarea from "@/components/form/Textarea";
import YesNo from "@/components/form/YesNo";
import { ui } from "@/components/ui";
import { Slider } from "@/components/ui/slider";
import type { InputKeyT } from "@/types/database/forms";
import React from "react";

interface InputSwitchProps {
	inputKey: InputKeyT;
	name: string;
	label?: string;
	description?: string;
}

const InputSwitchSimple = ({
	inputKey,
	name,
	label,
	description,
}: InputSwitchProps) => {
	switch (inputKey) {
		case "short-text":
			return (
				<Input
					name={name}
					label={label}
					description={description}
					type="text"
				/>
			);
		case "long-text":
			return <Textarea name={name} label={label} placeholder={label} />;
		case "number":
			return (
				<Input
					name={name}
					label={label}
					description={description}
					type="number"
				/>
			);
		case "yes-no":
			return <YesNo name={name} label={label || ""} />;
		case "date-picker":
			return <DateInput name={name} label={label} description={description} />;
		case "slider":
			return (
				<div className="space-y-2">
					{label && <ui.Label>{label}</ui.Label>}
					<ui.FormField
						name={name}
						render={({ field }) => (
							<Slider
								defaultValue={[(field.value as number) || 0]}
								onValueChange={([val]) => field.onChange(val || 0)}
								max={100}
								step={1}
								className="w-full"
							/>
						)}
					/>
				</div>
			);
		case "multiple-choice":
			return (
				<div className="space-y-2">
					{label && <ui.Label>{label}</ui.Label>}
					<ui.FormField
						name={name}
						render={({ field }) => (
							<ui.Select
								value={(field.value as string) || ""}
								onValueChange={(val) => field.onChange(val)}
							>
								<ui.SelectTrigger>
									<ui.SelectValue placeholder="Select an option" />
								</ui.SelectTrigger>
								<ui.SelectContent>
									{/* Options would need to be passed as a prop */}
								</ui.SelectContent>
							</ui.Select>
						)}
					/>
				</div>
			);
		case "single-choice":
			return (
				<div className="space-y-2">
					{label && <ui.Label>{label}</ui.Label>}
					<ui.FormField
						name={name}
						render={({ field }) => (
							<ui.RadioGroup
								value={(field.value as string) || ""}
								onValueChange={(val) => field.onChange(val)}
							>
								{/* Options would need to be passed as a prop */}
							</ui.RadioGroup>
						)}
					/>
				</div>
			);
		case "scale-rating":
			return (
				<div className="space-y-2">
					{label && <ui.Label>{label}</ui.Label>}
					<ui.FormField
						name={name}
						render={({ field }) => (
							<Slider
								defaultValue={[(field.value as number) || 0]}
								onValueChange={([val]) => field.onChange(val || 0)}
								max={10}
								step={1}
								className="w-full"
							/>
						)}
					/>
				</div>
			);
		case "star":
			return (
				<div className="space-y-2">
					{label && <ui.Label>{label}</ui.Label>}
					<ui.FormField
						name={name}
						render={({ field }) => (
							<Slider
								defaultValue={[(field.value as number) || 0]}
								onValueChange={([val]) => field.onChange(val || 0)}
								max={5}
								step={1}
								className="w-full"
							/>
						)}
					/>
				</div>
			);

		default:
			return null;
	}
};

export default InputSwitchSimple;
